import Service from '@ember/service';

import { service } from '@ember/service';

import ENV from 'rise-ui/config/environment.js';
import { minDate, maxDate } from 'rise-ui/config/time-series/query-params.js';
import { formatDate, offsetDate, parseDate } from 'rise-ui/utils/date.js';
import { join } from 'rise-ui/utils/string.js';
import { isSet } from 'rise-ui/utils/nullish.js';
import { readOnly } from 'rise-ui/utils/object/computed.js';

const API = ENV.APP.API.DATA;

export default class TimeSeriesDownloadModelService extends Service {
  @service('time-series/dates') timeSeriesDates;

  @readOnly('timeSeriesDates.itemDates') itemDateRanges;
  @readOnly('timeSeriesDates.modelRunDates') modelRunDateRanges;

  host = API.EXPOSED_URL;
  namespace = API.NAMESPACE;
  endpoint = 'result/download';

  get url() {
    const { endpoint, host, namespace } = this; // Consume
    return join([host, namespace, endpoint], '/');
  }

  link(options) {
    options = options || {};
    const { filename, itemId, modelRunId, type, disposition } = options;
    if (!filename || !type || (!itemId && !modelRunId)) {
      return;
    }

    let dates = itemId
      ? this.itemDateRanges[itemId]
      : this.modelRunDateRanges[modelRunId];
    dates = (dates && dates[0]) || {};
    const { from, to } = dates;
    const date = (date, add) =>
      formatDate(offsetDate(parseDate(date), add || 0, 'days'), 'short');

    const qps = {
      type,
      itemId,
      modelRunId,
      before: to && to !== minDate ? date(to) : undefined,
      after: from && from !== maxDate ? date(from) : undefined,
      filename: encodeURIComponent(filename),
      order: 'ASC',
      disposition,
    };
    return (
      this.url +
      '?' +
      Object.entries(qps)
        .filter(([k, v]) => isSet(k) && isSet(v))
        .map(([k, v]) => `${k}=${v}`)
        .join('&')
    );
  }

  getUrl(options) {
    return this.link(options) || 'javascript:void(0)';
  }
}
